import * as Sentry from "@sentry/nextjs";
import { useAtomValue } from "jotai";
import { useEffect } from "react";

import { accountAtom } from "shared/lib/account/atoms";

const vipEmails = new Set([
  "alan.hui@scmp.com",
  "ben.abbotts@scmp.com",
  "ben.li@scmp.com",
  "catherine.so@scmp.com",
  "cathy.hilbornfeng@scmp.com",
  "james.wilkinson@scmp.com",
  "john.yip@scmp.com",
  "libby.poon@scmp.com",
  "paul.buck@scmp.com",
  "ray.zhou@scmp.com",
  "raymond.kncheng@scmp.com",
  "shea.driscoll@scmp.com",
  "tom.eves@scmp.com",
]);

export const useSentrySetup = () => {
  const { user } = useAtomValue(accountAtom);

  useEffect(() => {
    if (!user) return;
    const scope = Sentry.getCurrentScope();
    scope.setUser({
      ...user,
    });
    scope.addEventProcessor(event => {
      // Avoid sending bunch of events if the user is not from internal
      // This is a workaround for changing the sample rate dynamically
      if (
        vipEmails.has(user.useremail) ||
        (Math.random() < 0.1 && user.useremail.includes("@scmp.com"))
      )
        return event;
      return null;
    });
  }, [user]);
};
